import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1fe8b447"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chat-view" }
const _hoisted_2 = { class: "chat-message-list" }

import ChatForm from '@/components/chat/ChatForm.vue'
import { getExchangeMessageList, sendExchangeMessage } from '@/store/actions/chat'
import { computed, reactive, watch } from 'vue'
import { iChatMessageModel, iExchangeModel } from '@/types/common/models'
import store from '@/store'
import useDataRequest from '@/composables/useDataRequest'
import MessageItem from '@/components/chat/MessageItem.vue'
import { ExchangeStatusColors, ExchangeStatusLabels } from '@/helpers/labels'
import ClipboardText from '@/components/shared/ClipboardText.vue'
import { formatUsdt } from '../../helpers/format'


export default /*#__PURE__*/_defineComponent({
  __name: 'ExchangeChat',
  props: {
    uuid: {}
  },
  emits: ['close'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const currentUser = computed(() => store.state.user)
const state = reactive<{
  exchange?: iExchangeModel
  messages: iChatMessageModel[]
  // С помощью него разрешаем делать скроллинг после загрузки картинок
  waitForImgLoad: boolean
}>({
  messages: [],
  waitForImgLoad: false
})

const requestState = useDataRequest({
  hideErrorMessages: true
})

const handleSubmit = async (form: FormData) => {
  if (!props.uuid) {
    return
  }

  return sendExchangeMessage(props.uuid, form)
}

const addMessage = (message: iChatMessageModel) => {
  state.messages.push(message)
}

const onImgLoad = () => {
  if (state.waitForImgLoad) {
    // Если картинки грузятся больше 2 секунд, делаем так, чтобы скроллинг не реагировал на их загрузку
    setTimeout(() => {
      state.waitForImgLoad = false
    }, 2000)
  }
}

// При добавлении сообщений скроллинг вниз
watch(() => state.messages.length, () => {
  state.waitForImgLoad = true
})

watch(() => [props.uuid], () => {
  if (props.uuid) {
    requestState.tryRequest(async () => {
      if (!props.uuid) {
        return
      }

      const { items, exchange } = await getExchangeMessageList(props.uuid)
      state.exchange = exchange
      state.messages = items
    })
  }
}, { immediate: true })

// Смотрим изменения сделки
const exchangeInStore = computed(() => store.state.exchanges.find(e => e.uuid === props.uuid))
watch(() => exchangeInStore.value, () => {
  if (exchangeInStore.value) {
    state.exchange = exchangeInStore.value
  }
})

// Забираем из store новые сообщения, в том числе когда они приходят
watch(() => store.state.chatExchangeMessages.length, () => {
  state.messages = [...state.messages, ...store.getChatMessages('exchange', props.uuid)]
    .filter((v, i, self) => i === self.indexOf(v))
}, { immediate: true })

watch(() => requestState.state.error, () => {
  emit('close')
})


return (_ctx: any,_cache: any) => {
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_countdown = _resolveComponent("el-countdown")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    "model-value": props.uuid !== undefined,
    onClose: _cache[0] || (_cache[0] = ($event: any) => (emit('close'))),
    title: "Чат по сделке"
  }, {
    footer: _withCtx(() => [
      _createVNode(ChatForm, {
        submit: handleSubmit,
        onSend: addMessage
      })
    ]),
    default: _withCtx(() => [
      (state.exchange)
        ? (_openBlock(), _createBlock(_component_el_descriptions, {
            key: 0,
            column: 1,
            style: {"margin-bottom":"32px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_descriptions_item, { label: "UUID" }, {
                default: _withCtx(() => [
                  _createVNode(ClipboardText, {
                    text: state.exchange?.uuid
                  }, null, 8, ["text"])
                ]),
                _: 1
              }),
              (state.exchange?.traderId === currentUser.value?.id)
                ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
                    key: 0,
                    label: "Счёт"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(state.exchange?.traderAccount?.name), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (state.exchange?.customerId === currentUser.value?.id)
                ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
                    key: 1,
                    label: "Реквизиты"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(state.exchange?.traderAccount?.value), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_el_descriptions_item, { label: "Сумма" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(formatUsdt)(state.exchange?.amount)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { label: "Статус" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_tag, {
                    "disable-transitions": "",
                    type: _unref(ExchangeStatusColors)[state.exchange?.status]
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(ExchangeStatusLabels)[state.exchange?.status]), 1)
                    ]),
                    _: 1
                  }, 8, ["type"])
                ]),
                _: 1
              }),
              (state?.exchange?.status === 'inProgress')
                ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
                    key: 2,
                    label: "Осталось"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_countdown, {
                        class: "countdown",
                        value: new Date(state.exchange?.expiresAt).getTime()
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.messages, (message) => {
            return (_openBlock(), _createBlock(MessageItem, {
              key: message.id,
              "chat-type": "exchange",
              message: message,
              onLoad: onImgLoad
            }, null, 8, ["message"]))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})